import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND_URL}/api` });
export const BACKEND = BACKEND_URL;

// Meta (enums para formularios)
export const getEnums = () => api.get("/meta/enums").then((r) => r.data);

// ------------------------- Planes de PRL -------------------------
export const getPlanesMeta = () => api.get("/planes/meta").then((r) => r.data);
export const getDashboard = () => api.get("/planes/dashboard").then((r) => r.data);

// Recordatorios / vencimientos
export const getRecordatoriosMeta = () => api.get("/recordatorios/meta").then((r) => r.data);
export const getRecordatoriosEmpresas = () => api.get("/recordatorios/empresas").then((r) => r.data);
export const getRecordatoriosTrabajadores = (empresaId) => api.get(`/recordatorios/empresa/${empresaId}/trabajadores`).then((r) => r.data);
export const listRecordatorios = (empresaId) => api.get("/recordatorios", { params: { empresa_id: empresaId } }).then((r) => r.data);
export const createRecordatorio = (data) => api.post("/recordatorios", data).then((r) => r.data);
export const updateRecordatorio = (id, data) => api.patch(`/recordatorios/${id}`, data).then((r) => r.data);
export const deleteRecordatorio = (id) => api.delete(`/recordatorios/${id}`).then((r) => r.data);
export const getSector = (clave) => api.get(`/sectores/${clave}`).then((r) => r.data);
export const listPlanes = (params = {}) => api.get("/planes", { params }).then((r) => r.data.items);
export const getPlan = (id) => api.get(`/planes/${id}`).then((r) => r.data);
export const createPlan = (data = {}) => api.post("/planes", data).then((r) => r.data);
export const updatePlan = (id, data) => api.patch(`/planes/${id}`, data).then((r) => r.data);
export const deletePlan = (id) => api.delete(`/planes/${id}`).then((r) => r.data);
export const uploadPlanFoto = (id, file, ambito = "visita", referencia = "") => {
  const fd = new FormData();
  fd.append("file", file);
  fd.append("ambito", ambito);
  fd.append("referencia", referencia);
  return api.post(`/planes/${id}/foto`, fd).then((r) => r.data);
};
export const deletePlanFoto = (id, fotoId) => api.delete(`/planes/${id}/foto/${fotoId}`).then((r) => r.data);
export const fotoUrl = (url) => `${BACKEND_URL}${url}`;

// IA
export const analizarPlan = (id) => api.post(`/planes/${id}/analizar`).then((r) => r.data);
export const getEstadoAnalisis = (id) => api.get(`/planes/${id}/analizar/estado`).then((r) => r.data);
export const generarPlan = (id) => api.post(`/planes/${id}/generar`).then((r) => r.data);
export const eliminarDocumentoPlan = (id) => api.delete(`/planes/${id}/documento`).then((r) => r.data);
export const generarInformeVisita = (id) => api.post(`/planes/${id}/informe-visita`).then((r) => r.data);
export const eliminarInformeVisita = (id, informeId) => api.delete(`/planes/${id}/informe-visita/${informeId}`).then((r) => r.data);
export const generarDocumentosIndividuales = (id) => api.post(`/planes/${id}/documentos-individuales`).then((r) => r.data);
export const borrarDocsTrabajador = (id, trabId) => api.delete(`/planes/${id}/documentos-trabajador/${trabId}`).then((r) => r.data);
export const borrarTodosDocsTrabajadores = (id) => api.delete(`/planes/${id}/documentos-trabajadores`).then((r) => r.data);
export const generarRecordatoriosDesdePlan = (id) => api.post(`/planes/${id}/generar-recordatorios`).then((r) => r.data);
export const generarFormacionTrabajador = (id, trabId, duracion) => api.post(`/planes/${id}/formacion-trabajador/${trabId}`, null, { params: duracion ? { duracion } : {} }).then((r) => r.data);
export const generarFormacionBatch = (id, duracion) => api.post(`/planes/${id}/formacion-batch`, null, { params: duracion ? { duracion } : {} }).then((r) => r.data);
export const getFormacionBatch = (id) => api.get(`/planes/${id}/formacion-batch`).then((r) => r.data);
export const marcarRecordatorioRealizado = (id, realizado) => api.patch(`/recordatorios/${id}/realizado`, { realizado }).then((r) => r.data);

// ------------------------- Módulo Suiza -------------------------
export const chGetMeta = () => api.get("/ch/meta").then((r) => r.data);
export const chListEmpresas = () => api.get("/ch/empresas").then((r) => r.data);
export const chCreateEmpresa = (data) => api.post("/ch/empresas", data).then((r) => r.data);
export const chGetEmpresa = (id) => api.get(`/ch/empresas/${id}`).then((r) => r.data);
export const chUpdateEmpresa = (id, data) => api.patch(`/ch/empresas/${id}`, data).then((r) => r.data);
export const chDeleteEmpresa = (id) => api.delete(`/ch/empresas/${id}`).then((r) => r.data);
export const chListDocumentos = (id) => api.get(`/ch/empresas/${id}/documentos`).then((r) => r.data);
export const chGenerarDocumento = (id, tipo, idioma, extra) => api.post(`/ch/empresas/${id}/documentos`, { tipo, idioma, extra }).then((r) => r.data);
export const chPrepararDocumento = (id, tipo, idioma = "es") => api.get(`/ch/empresas/${id}/preparar`, { params: { tipo, idioma } }).then((r) => r.data);
export const chAnalizarInfo = (id, tipo, idioma = "es") => api.post(`/ch/empresas/${id}/analizar`, { tipo, idioma }).then((r) => r.data);
export const chBorrarDocumento = (docId) => api.delete(`/ch/documentos/${docId}`).then((r) => r.data);
export const chListFirmas = (docId) => api.get(`/ch/documentos/${docId}/firmas`).then((r) => r.data);
export const chAddFirma = (docId, data) => api.post(`/ch/documentos/${docId}/firmas`, data).then((r) => r.data);
export const chDelFirma = (docId, firmaId) => api.delete(`/ch/documentos/${docId}/firmas/${firmaId}`).then((r) => r.data);
export const chActualizarDocumento = (docId, data) => api.patch(`/ch/documentos/${docId}`, data).then((r) => r.data);
export const chSubirFotoEmpresa = (eid, file, bloque = "") => {
  const fd = new FormData();
  fd.append("file", file);
  fd.append("bloque", bloque);
  return api.post(`/ch/empresas/${eid}/foto`, fd).then((r) => r.data);
};
export const chBorrarFotoEmpresa = (eid, fid) => api.delete(`/ch/empresas/${eid}/foto/${fid}`).then((r) => r.data);
// Formularios públicos Suiza (bilingüe)
export const chListFormularios = (empresaId) => api.get("/ch/formularios", { params: empresaId ? { empresa_id: empresaId } : {} }).then((r) => r.data);
export const chCrearFormulario = (data) => api.post("/ch/formularios", data).then((r) => r.data);
export const chBorrarFormulario = (formId) => api.delete(`/ch/formularios/${formId}`).then((r) => r.data);
export const chImportarFormulario = (formId) => api.post(`/ch/formularios/${formId}/importar`).then((r) => r.data);
export const chGetFormularioPublico = (token) => api.get(`/ch/f/${token}`).then((r) => r.data);
export const chGuardarFormularioPublico = (token, data) => api.patch(`/ch/f/${token}`, data).then((r) => r.data);
export const chCompletarFormularioPublico = (token) => api.post(`/ch/f/${token}/completar`).then((r) => r.data);
export const chSubirFotoFormulario = (token, file) => {
  const fd = new FormData();
  fd.append("file", file);
  return api.post(`/ch/f/${token}/foto`, fd).then((r) => r.data);
};
export const chBorrarFotoFormulario = (token, fotoId) => api.delete(`/ch/f/${token}/foto/${fotoId}`).then((r) => r.data);

// --- Nueva arquitectura Suiza (centros / puestos / inspecciones) — Fase 1
export const chListCentros = (eid) => api.get(`/ch/empresas/${eid}/centros`).then((r) => r.data);
export const chCrearCentro = (eid, data) => api.post(`/ch/empresas/${eid}/centros`, data).then((r) => r.data);
export const chGetCentro = (cid) => api.get(`/ch/centros/${cid}`).then((r) => r.data);
export const chEditarCentro = (cid, data) => api.patch(`/ch/centros/${cid}`, data).then((r) => r.data);
export const chBorrarCentro = (cid) => api.delete(`/ch/centros/${cid}`).then((r) => r.data);
export const chListPuestosEmpresa = (eid) => api.get(`/ch/empresas/${eid}/puestos`).then((r) => r.data);
export const chListPuestosCentro = (cid) => api.get(`/ch/centros/${cid}/puestos`).then((r) => r.data);
export const chCrearPuesto = (cid, data) => api.post(`/ch/centros/${cid}/puestos`, data).then((r) => r.data);
export const chEditarPuesto = (pid, data) => api.patch(`/ch/puestos/${pid}`, data).then((r) => r.data);
export const chBorrarPuesto = (pid) => api.delete(`/ch/puestos/${pid}`).then((r) => r.data);
export const chListInspeccionesEmpresa = (eid) => api.get(`/ch/empresas/${eid}/inspecciones`).then((r) => r.data);
export const chCrearInspeccion = (cid, data) => api.post(`/ch/centros/${cid}/inspecciones`, data).then((r) => r.data);
export const chGetInspeccion = (iid) => api.get(`/ch/inspecciones/${iid}`).then((r) => r.data);
export const chEditarInspeccion = (iid, data) => api.patch(`/ch/inspecciones/${iid}`, data).then((r) => r.data);

// --- Checklist maestro de la inspección (Fase 2)
export const chGetChecklist = (iid) => api.get(`/ch/inspecciones/${iid}/checklist`).then((r) => r.data);
export const chPatchChecklist = (iid, data) => api.patch(`/ch/inspecciones/${iid}/checklist`, data).then((r) => r.data);
export const chSubirFotoInspeccion = (iid, file, itemId = "") => {
  const fd = new FormData();
  fd.append("file", file);
  fd.append("item_id", itemId);
  return api.post(`/ch/inspecciones/${iid}/foto`, fd).then((r) => r.data);
};
export const chBorrarFotoInspeccion = (iid, fid) => api.delete(`/ch/inspecciones/${iid}/foto/${fid}`).then((r) => r.data);
// --- Análisis IA de la inspección (Fase 3)
export const chAnalizarInspeccion = (iid, idioma = "fr") => api.post(`/ch/inspecciones/${iid}/analizar`, { idioma }).then((r) => r.data);
export const chEstadoAnalisisInspeccion = (iid) => api.get(`/ch/inspecciones/${iid}/analizar/estado`).then((r) => r.data);
export const chGuardarRevisionInspeccion = (iid, data) => api.patch(`/ch/inspecciones/${iid}/revision`, data).then((r) => r.data);
// --- Documentos desde la inspección (Fase 4)
export const chListDocsInspeccion = (iid) => api.get(`/ch/inspecciones/${iid}/documentos`).then((r) => r.data);
export const chGenerarDocInspeccion = (iid, data) => api.post(`/ch/inspecciones/${iid}/documentos`, data).then((r) => r.data);
export const chGenerarPlanConsolidado = (eid, data) => api.post(`/ch/empresas/${eid}/plan-consolidado`, data).then((r) => r.data);
export const chBorrarDocumentoCh = (docId) => api.delete(`/ch/documentos/${docId}`).then((r) => r.data);
export const chBorrarInspeccion = (iid) => api.delete(`/ch/inspecciones/${iid}`).then((r) => r.data);
export const chGetSeguimiento = (eid, centroId = "") =>
  api.get(`/ch/empresas/${eid}/seguimiento`, { params: centroId ? { centro_id: centroId } : {} }).then((r) => r.data);
export const chActualizarSeguimiento = (iid, data) => api.patch(`/ch/inspecciones/${iid}/seguimiento`, data).then((r) => r.data);
export const chCompararInspecciones = (cid, a, b) =>
  api.get(`/ch/centros/${cid}/comparar`, { params: { a, b } }).then((r) => r.data);
export const duplicarPlan = (id, incluir = []) => api.post(`/planes/${id}/duplicar`, { incluir }).then((r) => r.data);
export const getConfigIa = () => api.get("/config-ia").then((r) => r.data);
export const getConfigIaModelos = () => api.get("/config-ia/modelos").then((r) => r.data);
export const putConfigIa = (data) => api.put("/config-ia", data).then((r) => r.data);

// Formularios externos para clientes (Fase 1)
export const crearFormulario = (planId, tipo = "general") => api.post(`/planes/${planId}/formularios`, { tipo }).then((r) => r.data);
export const listarFormularios = (planId) => api.get(`/planes/${planId}/formularios`).then((r) => r.data);
export const eliminarFormulario = (formId) => api.delete(`/formularios/${formId}`).then((r) => r.data);
export const importarFormulario = (planId, formId) => api.post(`/planes/${planId}/formularios/${formId}/importar`).then((r) => r.data);
export const iniciarPreanalisis = (planId, formId) => api.post(`/planes/${planId}/formularios/${formId}/preanalisis`).then((r) => r.data);
export const getPreanalisis = (formId) => api.get(`/formularios/${formId}/preanalisis`).then((r) => r.data);
export const formularioPdfUrl = (formId) => `${BACKEND_URL}/api/formularios/${formId}/pdf`;
// Formularios independientes (pestaña propia, sin empresa ni plan)
export const crearFormularioLibre = (nombre) => api.post(`/formularios`, { nombre }).then((r) => r.data);
export const listarFormulariosLibres = () => api.get(`/formularios`).then((r) => r.data);
// Público (por token)
export const getFormularioPublico = (token) => api.get(`/f/${token}`).then((r) => r.data);
export const guardarFormularioPublico = (token, data) => api.patch(`/f/${token}`, data).then((r) => r.data);
export const completarFormularioPublico = (token) => api.post(`/f/${token}/completar`).then((r) => r.data);
export const subirFotoFormulario = (token, file, bloqueOrden) => {
  const fd = new FormData();
  fd.append("file", file);
  fd.append("bloque_orden", bloqueOrden);
  return api.post(`/f/${token}/foto`, fd).then((r) => r.data);
};
export const borrarFotoFormulario = (token, fotoId) => api.delete(`/f/${token}/foto/${fotoId}`).then((r) => r.data);
export const borrarVideoFormulario = (token) => api.delete(`/f/${token}/video`).then((r) => r.data);
export const subirVideoChunk = (token, chunk, index, total, filename) => {
  const fd = new FormData();
  fd.append("chunk", chunk);
  fd.append("index", index);
  fd.append("total", total);
  fd.append("filename", filename);
  return api.post(`/f/${token}/video/chunk`, fd).then((r) => r.data);
};

// Empresas
export const listEmpresas = (search = "") =>
  api.get("/empresas", { params: { search } }).then((r) => r.data.items);
export const getEmpresa = (id) => api.get(`/empresas/${id}`).then((r) => r.data);
export const createEmpresa = (data) => api.post("/empresas", data).then((r) => r.data);
export const updateEmpresa = (id, data) => api.put(`/empresas/${id}`, data).then((r) => r.data);
export const deleteEmpresa = (id) => api.delete(`/empresas/${id}`).then((r) => r.data);

// Configuración de la consultora (motor documental) + IA
export const getDocConfig = () => api.get("/documental/config").then((r) => r.data);
export const putDocConfig = (data) => {
  const fd = new FormData();
  Object.entries(data).forEach(([k, v]) => fd.append(k, v ?? ""));
  return api.put("/documental/config", fd).then((r) => r.data);
};
export const uploadConfigImagen = (file, tipo) => {
  const fd = new FormData();
  fd.append("file", file);
  fd.append("tipo", tipo);
  return api.post("/documental/config/logo", fd).then((r) => r.data);
};
